var _effectorFileName = "/src/widgets/layouts/main/components/header/header.tsx";
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useTranslation } from 'next-i18next';
import GroupLessonsIcon from '@/shared/components/icons/group-lessons-icon';
import IndividualLessonsIcon from '@/shared/components/icons/individual-lessons-icon';
import PairLessonsIcon from '@/shared/components/icons/pair-lessons-icon';
import { LanguageSwitcher } from '@/shared/components/language-switcher';
import { Logo } from '@/shared/components/logo';
import { ThemeToggle } from '@/shared/components/theme-toggle';
import { Button } from '@/shared/components/ui/button';
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuList, NavigationMenuTrigger } from '@/shared/components/ui/navigation-menu';
import { cn } from '@/shared/lib/cn';
export const Header = () => {
  const {
    t
  } = useTranslation('layout-header');
  const Sidebar = dynamic(() => import('@/widgets/layouts/main/components/sidebar').then(components => components.Sidebar));
  const pathname = usePathname();
  return <header className="fixed top-0 z-50 w-full border-b border-border/40 bg-background/95 py-4 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex items-center justify-between">
        <Logo />

        <NavigationMenu className="hidden lg:block">
          <NavigationMenuList className="space-x-0 md:space-x-1">
            <NavigationMenuItem>
              <NavigationMenuTrigger>{t('nav.services')}</NavigationMenuTrigger>

              <NavigationMenuContent>
                <ul className="gap-3 p-4 sm:w-[300px] lg:w-[400px]">
                  <li>
                    <Link className={cn({
                    'text-brand-accent-dark dark:text-brand-accent-normal': pathname === '/individual-lessons'
                  })} href="/individual-lessons" aria-label={t('services.individual.aria')}>
                      <div className="group rounded-md p-2 hover:bg-secondary">
                        <div className="mb-1 flex items-center">
                          <IndividualLessonsIcon className="mr-2 h-5 w-5" />
                          <span className="text-sm group-hover:underline group-hover:decoration-brand-accent-normal">
                            {t('services.individual.title')}
                          </span>
                        </div>

                        <p className="text-xss text-muted-foreground">{t('services.individual.description')}</p>
                      </div>
                    </Link>
                  </li>

                  {/* <li>
                    <Link
                      className={cn({
                        'text-brand-accent-dark dark:text-brand-accent-normal': pathname === '/group-lessons',
                      })}
                      href="/group-lessons"
                      aria-label={t('services.group.aria')}
                    >
                      <div className="group rounded-md p-2 hover:bg-secondary">
                        <div className="mb-1 flex items-center">
                          <GroupLessonsIcon className="mr-2 h-5 w-5" />
                          <span className="text-sm group-hover:underline group-hover:decoration-brand-accent-normal">
                            {t('services.group.title')}
                          </span>
                        </div>
                         <p className="text-xss text-muted-foreground">{t('services.group.description')}</p>
                      </div>
                    </Link>
                   </li> */}

                  <li>
                    <Link className={cn({
                    'text-brand-accent-dark dark:text-brand-accent-normal': pathname === '/individual-lessons'
                  })} href="/pair-lessons" aria-label={t('services.individual.aria')}>
                      <div className="group rounded-md p-2 hover:bg-secondary">
                        <div className="mb-1 flex items-center">
                          <PairLessonsIcon className="mr-2 h-5 w-5" />
                          <span className="text-sm group-hover:underline group-hover:decoration-brand-accent-normal">
                            {t('services.pair.title')}
                          </span>
                        </div>

                        <p className="text-xss text-muted-foreground">{t('services.pair.description')}</p>
                      </div>
                    </Link>
                  </li>
                </ul>
              </NavigationMenuContent>
            </NavigationMenuItem>

            <NavigationMenuItem>
              <Link href="/teachers" aria-label={t('aria.teachers')}>
                <Button className={cn({
                'text-brand-accent-dark dark:text-brand-accent-normal': pathname === '/teachers'
              })} variant="link" aria-label={t('aria.teachers')}>
                  {t('nav.teachers')}
                </Button>
              </Link>
            </NavigationMenuItem>

            <NavigationMenuItem>
              <Link href="/cases" aria-label={t('aria.cases')}>
                <Button className={cn({
                'text-brand-accent-dark dark:text-brand-accent-normal': pathname === '/cases'
              })} variant="link" aria-label={t('aria.cases')}>
                  {t('nav.cases')}
                </Button>
              </Link>
            </NavigationMenuItem>

            <NavigationMenuItem>
              <Link href={process.env.NEXT_PUBLIC_B2B_URL ?? ''} target="_blank" rel="noopener" aria-label={t('aria.forCompanies')}>
                <Button className={cn({
                'text-brand-accent-dark dark:text-brand-accent-normal': pathname === '/for-companies'
              })} variant="link" aria-label={t('aria.forCompanies')}>
                  {t('nav.forCompanies')}
                </Button>
              </Link>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>

        <div className="flex items-center gap-4">
          {process.env.NEXT_PUBLIC_APP_STAGE !== 'production' && <Link href="/login" className="hidden lg:block">
              <Button size="icon" variant="secondary" className={cn({
            'text-brand-accent-dark dark:text-brand-accent-normal': pathname === '/login'
          })}>
                <span className="sr-only">{t('nav.login')}</span>
                <IndividualLessonsIcon className="h-5 w-5" />
              </Button>
            </Link>}

          <div className="hidden lg:block">
            <LanguageSwitcher />
          </div>

          <div className="hidden lg:block">
            <ThemeToggle withText={false} />
          </div>

          <div className="block lg:hidden">
            <Sidebar />
          </div>
        </div>
      </div>
    </header>;
};